import React, { useState } from "react";
import { Link } from "react-router-dom";
import DonatePopup from "./DonatePopup";

export default function Footer() {
  const [showDonatePopup, setShowDonatePopup] = useState(false);

  return (
    <footer className="relative text-white text-sm font-[arial] overflow-hidden">
      {/* ✦ Background Image ✦ */}

      {/* ✦ Blur + White Overlay ✦ */}
      <div className="absolute inset-0 -z-20 backdrop-blur-xl bg-[white]/30 border border-[white]/40" />

      {/* ✦ Content Container ✦ */}
      <div className="relative max-w-6xl mx-auto px-4 py-4 grid grid-cols-1 md:grid-cols-4 gap-4 text-left text-sm text-[#021868]">
        {/* Explore + Emotions Combined Horizontally */}
        <div className="col-span-2 flex flex-wrap gap-x-6 gap-y-2 md:border-r border-[#d9c8ec]/50 pr-4">
          <div>
            <h3 className="text-xs font-semibold mb-1 border-b border-[#d9c8ec]/50 pb-[2px]">Explore</h3>
            <ul className="flex flex-wrap gap-x-4 gap-y-[2px] text-xs">
              {[
                { to: "/", text: "Home" },
                { to: "/tarot-cards", text: "All Cards" },
                { to: "/what-is-tarot-cards-complete-guide", text: "What Is Tarot?" },
                { to: "/tarot/major-arcana-tarot-suit-cards-meaning", text: "Major Arcana" },
                { to: "/tarot/wands-tarot-suit-cards-meaning", text: "Wands" },
                { to: "/tarot/cups-tarot-suit-cards-meaning", text: "Cups" },
                { to: "/tarot/swords-tarot-suit-cards-meaning", text: "Swords" },
                { to: "/tarot/pentacles-tarot-suit-cards-meaning", text: "Pentacles" },
              ].map((link) => (
                <li key={link.to}><Link to={link.to} className="hover:underline">{link.text}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold mb-1 border-b border-[#d9c8ec]/50 pb-[2px] mt-2">Read by Emotion</h3>
            <ul className="flex flex-wrap gap-x-4 gap-y-[2px] text-xs">
              {[
                "uncertain-love", "heart-broken", "anxious", "confused", "lonely",
                "hopeless", "guilty", "betrayed", "insecure", "overwhelmed", "other"
              ].map((slug) => (
                <li key={slug}>
                  <Link to={`/emotions/${slug}`} className="hover:underline capitalize">
                    {slug.replace(/-/g, ' ')}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Site Info */}
        <div className="text-xs md:border-r border-[#d9c8ec]/50 pr-4">
          <h3 className="text-xs font-semibold mb-1 border-b border-[#d9c8ec]/50 pb-[2px]">This Space</h3>
          <ul className="space-y-[2px]">
            <li><Link to="/about" className="hover:underline">About</Link></li>
            <li><Link to="/privacy" className="hover:underline">Privacy Policy</Link></li>
            <li><Link to="/disclaimer" className="hover:underline">Disclaimer</Link></li>
          </ul>
        </div>

        {/* Mystic Whisper + Donate */}
        <div className="flex flex-col justify-between text-xs">
          <div>
            <h3 className="text-xs font-semibold mb-1 border-b border-[#d9c8ec]/50 pb-[2px]">Mystic Whisper</h3>
            <p className="italic text-[#021868] leading-tight mb-2">
              “In silence, the soul hears what the world forgets.”
            <br></br><br></br>- This space is created with love by the stars that guide us</p>
            <button
              onClick={() => setShowDonatePopup(true)}
              className="bg-white/40 text-[#021868] border border-[#021868]/60 px-3 py-[2px] rounded-full text-xs hover:bg-[#f5f1fa] transition"
            >
              💖 Donate
            </button>
          </div>
        </div>
      </div>

      {/* ✦ Bottom Bar ✦ */}
      <div className="text-center text-[14px] text-[#021868] border-t border-[#d9c8ec]/50 py-2 px-4">
        © {new Date().getFullYear()} TarotFate.com | All rights reserved</div> 
<div className="text-center text-[13px] text-[#3f2850] py-2 px-4">
      </div>
      <DonatePopup show={showDonatePopup} onClose={() => setShowDonatePopup(false)} />
    </footer>
  );
}
